import type { RootState } from '@/app/store';

export const selectAnalyticsOverview = (state: RootState) => state.analytics.overview;
export const selectAttendeeEngagement = (state: RootState) => state.analytics.engagement;
export const selectPastWebinarsData = (state: RootState) => state.analytics.pastWebinars;
export const selectCurrentSessionDetails = (state: RootState) => state.analytics.currentSession;
export const selectSelectedParticipant = (state: RootState) => state.analytics.selectedParticipant;
export const selectComparison = (state: RootState) => state.analytics.comparison;
export const selectReplayDownload = (state: RootState) => state.analytics.replayDownload;

export const selectParticipantProfile = (state: RootState) =>
  state.analytics.selectedParticipant.details?.profile;

export const selectParticipantInteractions = (state: RootState) =>
  state.analytics.selectedParticipant.details?.interactions;

export const selectParticipantEngagement = (state: RootState) =>
  state.analytics.selectedParticipant.details?.engagement;
